/* Reducers: */
const byId = (state = {}, action) => {
  if (!action.edition) {
    return state;
  }
  switch (action.type) {
    case 'RECIEVE_PEOPLE': // eslint-disable-line no-case-declarations
      const nextState = { ...state };
      Object.keys(action.response).forEach((type) => {
        action.response[type].forEach((item) => {
          nextState[item.id] = item;
        });
      });
      return nextState;
    default:
      return state;
  }
};

export default byId;

/* Selectors: */
export const getPerson = (state, id) => state[id];



// WEBPACK FOOTER //
// ./js/reducers/people/byId.js